import { observer } from "mobx-react-lite";
import { Button, ButtonProps } from "@chakra-ui/react";

import { langStore, translate } from "@noli/business";
import Uploader, { UploaderProps } from ".";

function Upload({
  className,
  addToBoard,
  onUpload,
  ...others
}: ButtonProps & Pick<UploaderProps, "addToBoard" | "onUpload">) {
  const lang = langStore.tgt;

  return (
    <Uploader className={className} addToBoard={addToBoard} onUpload={onUpload}>
      <Button w="100%" {...others}>
        {translate("upload-image", lang)}
      </Button>
    </Uploader>
  );
}

export const UploadButton = observer(Upload);
